import editAddressModalTemplate from '../views/edit-address-modal.tpl.html';

class ShippingDetailsCtrl {
    constructor(locale, SweetAlert, $stateParams, $http, $state, NavService, $rootScope, $uibModal, Acl, FileSaver, Blob) {
        this.locale = locale;
        this.sweetAlert = SweetAlert;
        this.stateParams = $stateParams;
        this.api = $http;
        this.state = $state;
        this.navService = NavService;
        this.shipping = null;
        this.rootScope = $rootScope;
        this.uibModal = $uibModal;
        this.fileSaver = FileSaver;
        this.blob = Blob;
        this.acl = Acl;

        this.loadShipping();
    }

    loadShipping() {
        this.api.get(`shipping/${this.stateParams.sid}`).then((response) => {
            this.shipping = response.data.data;
            this.updateBreadcrumbParams();
        }, () => {
            this.sweetAlert.error('Error', 'There was an error while loading the shipping');
            this.state.go('app.shippings.index');
        });
    }

    printLabel() {
        this.api.post(`shipping/${this.shipping.id}/print-label`).then(() => {
            this.sweetAlert.success('Print started', 'The label print was started');
        }, () => {
            this.sweetAlert.error('Print error', 'Error while printing label for shipping');
        });
    }

    downloadLabel() {
        this.api.post(`shipping/${this.shipping.id}/download-label`, {}, {responseType: "blob"}).then((response) => {
            const blob = new this.blob([response.data], {type: response.headers('content-type')});

            this.fileSaver.saveAs(blob, 'Shipping label.pdf');
        }, () => {
            this.sweetAlert.error('Download error', 'Error while downloading delivery note for shipping');
        });
    }

    printDeliveryNote() {
        this.api.post(`shipping/${this.shipping.id}/print-delivery-note`).then(() => {
            this.sweetAlert.success('Print started', 'The delivery note print was started');
        }, () => {
            this.sweetAlert.error('Print error', 'Error while printing delivery note for shipping');
        });
    }

    downloadDeliveryNote() {
        this.api.post(`shipping/${this.shipping.id}/download-delivery-note`, {}, {responseType: "blob"}).then((response) => {
            const blob = new this.blob([response.data], {type: response.headers('content-type')});

            this.fileSaver.saveAs(blob, 'Delivery note.pdf');
        }, () => {
            this.sweetAlert.error('Download error', 'Error while downloading delivery note for shipping');
        });
    }

    printDocuments() {
        this.api.post(`shipping/${this.shipping.id}/print-documents`).then(() => {
            this.sweetAlert.success('Print started', 'Printing documents was started');
        }, () => {
            this.sweetAlert.error('Print error', 'Error while printing documents for shipping');
        });
    }

    sendNotice() {
        this.api.post(`shipping/${this.shipping.id}/send-notice`).then(() => {
            this.sweetAlert.success('Notice queued', 'The notice messages was queued.');
        }, () => {
            this.sweetAlert.error('Send Error', 'Error while sending notice.');
        });
    }

    editAddress() {
        return this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: editAddressModalTemplate,
            size: 'lg',
            controller: 'EditAddressModalCtrl',
            controllerAs: 'vm',
            resolve: {
                shipping: this.shipping
            }
        });
    }

    updateBreadcrumbParams() {
        let customActions = [];

        if (this.acl.hasModule('shipping') && this.rootScope.company.settings.shipping.used_shipping_provider > -1) {
            if (this.acl.hasRight('shipping::print-label')) {
                customActions.push({
                    label: 'Print Label',
                    action: () => {
                        this.printLabel();
                    },
                    icon: 'print',
                    order: 5
                });

                customActions.push({
                    label: 'Download label',
                    action: () => {
                        this.downloadLabel();
                    },
                    icon: 'download',
                    order: 5.5
                });
            }

            if (this.acl.hasRight('shipping::print-documents')) {
                customActions.push({
                    label: 'Print Documents',
                    action: () => {
                        this.printDocuments();
                    },
                    icon: 'print',
                    order: 5
                });

                customActions.push({
                    label: 'Print delivery note',
                    action: () => {
                        this.printDeliveryNote();
                    },
                    icon: 'print',
                    order: 6
                });

                customActions.push({
                    label: 'Download delivery note',
                    action: () => {
                        this.downloadDeliveryNote();
                    },
                    icon: 'download',
                    order: 7
                });
            }
        }

        // show "edit address" only if there is no provider information
        // if there is provider information, the shipping is already processed by the provider
        if (!this.shipping.provider_processed && this.acl.hasRight('shipping::edit')) {
            customActions.push({
                label: 'Edit Address',
                action: () => {
                    this.editAddress();
                },
                icon: 'address-card',
                order: 10
            });
        }

        if (this.shipping.provider_processed && this.acl.hasRight('shipping::send-shipping-notice')) {
            customActions.push({
                label: 'Send Notice',
                action: () => {
                    this.sendNotice();
                },
                icon: 'envelope',
                order: 10
            });
        }

        this.navService.overrideMainSideNavActions(customActions);

        this.navService.setBreadcrumbParameters({
            id: this.shipping ? this.shipping.id : '',
            contact_name: this.shipping ? (this.shipping.contact.business_preferred ? this.shipping.contact.company_name : this.shipping.contact.full_name) : ''
        });
    }
}

ShippingDetailsCtrl.$inject = [
    'locale',
    'SweetAlert',
    '$stateParams',
    '$http',
    '$state',
    'NavService',
    '$rootScope',
    '$uibModal',
    'Acl',
    'FileSaver',
    'Blob'
];


angular
    .module('festzelt-os.shippings')
    .controller('ShippingDetailsCtrl', ShippingDetailsCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/shippings/controllers/details-controller.js